import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IListProps extends React.HTMLAttributes<HTMLUListElement> {
  block?: boolean;
  inline?: boolean;
}

export function List({ className, block, inline, children, ...otherProps }: IListProps): React.ReactElement {
  const bem = bemBlock('list');

  return (
    <ul className={bem(null, [{ inline }, { block }], className)} {...otherProps}>
      {children}
    </ul>
  );
}
